import { FC } from 'react';
import { DigitalFormsFormsKioskSvg } from '@frontend/digital-forms-assets';
import { Trans, useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Heading, Text } from '@frontend/design-system';
import { KioskTypes } from '../../../../types';
import { buttonContainerStyle, containerStyle } from './welcome-page-content.styles';

interface Props {
  onSelectPatientType: (patientType: KioskTypes.Patron) => void;
}

export const WelcomePageContent: FC<Props> = ({ onSelectPatientType }) => {
  const { t } = useTranslation('digital-forms-experience');

  return (
    <section css={containerStyle}>
      <DigitalFormsFormsKioskSvg width={'50%'} css={{ alignSelf: 'center' }} aria-label={t('Kiosk Image')} />
      <div>
        <Heading as='h1' level={2}>
          {t('Welcome')}
        </Heading>
        <Text color='subdued' css={{ marginTop: theme.spacing(0.5) }}>
          <Trans t={t}>
            Please select <strong>New Patient</strong> or <strong>Existing Patient</strong> to begin.
          </Trans>
        </Text>
      </div>

      <div css={buttonContainerStyle}>
        <Button variant='primary' size='large' onClick={() => onSelectPatientType('new')}>
          {t('New Patient')}
        </Button>
        <Button variant='secondary' size='large' onClick={() => onSelectPatientType('existing')}>
          {t('Existing Patient')}
        </Button>
      </div>
    </section>
  );
};
